import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { UserRole } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetAllOrganisationUserRoles = (orgId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<UserRole[]>(
    [QueryEntity.UserRoles],
    async () => {
      const url = new URL(`${APIBaseChronos}/api/org/${orgId}/roles`);
      try {
        const res = await fetch(url.toString(), fetchConfigGET);
        if (!res.ok) {
          throw new Error('Failed to fetch organisation user roles');
        }
        return await res.json();
      } catch (err) {
        console.error(err);
      }
    },
    {
      enabled: !!orgId,
    },
  );
};
